export interface AutoOrderRequest {
  id: number
}

export function AutoOrderRequestToJSON(value: AutoOrderRequest): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
